<section class="faq-page" aria-label="Frequently asked questions">
  <mat-card class="faq-card" appearance="outlined">
    <mat-card-header>
      <mat-card-title>FAQs</mat-card-title>
      <mat-card-subtitle>Answers to common questions about PAXI Express delivery.</mat-card-subtitle>
    </mat-card-header>

    <mat-card-content>
      @for (item of faqs(); track item.question) {
        <article class="faq-item">
          <h2>{{ item.question }}</h2>
          <p>{{ item.answer }}</p>
        </article>
      }

      <a mat-stroked-button routerLink="/">Back to availability check</a>
    </mat-card-content>
  </mat-card>
</section>
